import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IdentityService } from 'src/app/core/identity.service';
import { PerDiemRecruitingService } from 'src/app/perdiem-recruiting/perdiem-recruiting.service';
import { RecruiterResourcesBaseComponent } from 'src/app/recruiting/candidates/new-profile/recruiter-resources/recruiter-resources-base.component';
import { FollowupPickerPerdiemComponent } from 'src/app/shared/components/followup-picker-perdiem/followup-picker-perdiem.component';
import { PerDiemFollowupView } from 'src/app/shared/models/perdiem-followup-view.model';

@UntilDestroy()
@Component({
    selector: 'nova-perdiem-recruiter-resources',
    templateUrl: './perdiem-recruiter-resources.component.html',
    styleUrls: ['./perdiem-recruiter-resources.component.scss'],
    standalone: true,
    imports: [FollowupPickerPerdiemComponent]
})
export class PerdiemRecruiterResourcesComponent extends RecruiterResourcesBaseComponent {
    followup: PerDiemFollowupView;
    canEdit = false;

    constructor(
        private readonly _route: ActivatedRoute,
        private readonly _recruitingService: PerDiemRecruitingService,
        private readonly _identityService: IdentityService
    ) {
        super(_route, _identityService);
    }

    public requestRecruiterFollowupForCandidate(): void {
        this.setCanEdit();
        this._recruitingService.getRecruiterFollowupForCandidate(this.candidateId).subscribe((data) => {
            if (data) {
                this.followup = data;
            } else {
                this.followup = {
                    candidateId: this.candidateId,
                    priority: 1,
                    followupDate: null,
                    recruiterId: this.recruiterId,
                    followupReason: ''
                };
            }
            this.isDoneLoading = true;
        });
    }

    setCanEdit(): void {
        this._recruitingService.getCanEditFollowUpForCandidate(this.candidateId, this.recruiterId).subscribe((data) => {
            this.canEdit = data;
        });
    }
}
